__turbopack_context__.v({
  "product-body": "ProductCardBody-module-scss-module__xV7o0G__product-body",
  "product-body__description": "ProductCardBody-module-scss-module__xV7o0G__product-body__description",
  "product-body__description-list": "ProductCardBody-module-scss-module__xV7o0G__product-body__description-list",
  "product-body__icons": "ProductCardBody-module-scss-module__xV7o0G__product-body__icons",
  "product-body__icons--gas": "ProductCardBody-module-scss-module__xV7o0G__product-body__icons--gas",
  "product-icon": "ProductCardBody-module-scss-module__xV7o0G__product-icon",
});
